<template>
  <tr>
    <td>{{ order.id }}</td>
    <td>
      <router-link :to="`/orders/${order.id}`">
        {{ order.date ? order. date : order.created_at | datetime }}
      </router-link>
    </td>
    <td>
      <span :class="{'text-danger': order.warehouse.deleted_at }">{{ order.warehouse.name }}</span>
    </td>
    <td v-if="showSupplier">
      <router-link :to="`/suppliers/${order.supplier_id}`"
      >
        {{ order.supplier.name }}
      </router-link>
    </td>
    <td class="text-right">{{ orderSum | priceFromCentEuro }}</td>
    <td class="text-center">
      <a href="#" @click.prevent="$emit('openProducts', order)">
        <i class="fas fa-boxes" aria-hidden="true"></i>
      </a>
    </td>
    <td class="text-center">
      <el-select :class="selectClass"
        placeholder="Status"
        v-model="order.status"
        @change="$emit('changeStatus', order)"
      >
        <el-option v-for="option in statusOptions"
          :class="option.class"
          :value="option.value"
          :label="option.label"
          :key="option.value"
        />
      </el-select>
    </td>
    <td>
      <div v-if="order.status === 'ordered' && ! order.products_registered_at">
        <a href="#" @click.prevent="$emit('createStockRotationsFromOrder', order)">
          <i class="fas fa-long-arrow-alt-left"></i> Produkte einbuchen
        </a>
      </div>
      <div v-if="order.status === 'incomplete'">
        <a href="#" @click.prevent="$emit('createStockRotationsFromOrder', order)">
          <i class="fas fa-long-arrow-alt-left"></i> Weitere Produkte einbuchen
        </a>
      </div>
      <div v-if="order.products_registered_at && order.status !== 'incomplete'">
        <i class="fas fa-check"></i> Produkte eingebucht
      </div>
    </td>
    <td class="text-right">
      <div class="td-actions">
        <router-link 
        :to="`/orders/create?orderId=${order.id}`"
        v-tooltip.top-center="'Bestellung erneut aufgeben'" 
        class="btn btn-info btn-link btn-xs">
        <i class="fas fa-redo"></i>
      </router-link>
        <a href="#" v-tooltip.top-center="'Versenden'" class="btn btn-primary btn-link btn-xs"
          @click.prevent="$emit('openSendOrderDialog', order)"
          style="margin-right: 16px;"
        >
          <i class="fas fa-envelope"></i>
        </a>
        <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
           @click="$emit('editOrder', order)">
          <i class="fa fa-edit"></i>
        </a>
        <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
           @click="$emit('deleteOrder', order)">
          <i class="fa fa-close"></i>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import { Select, Option } from 'element-ui'
import orderStatusOptions from 'src/orderStatusOptions'

export default {
  props: {
    order: null,
    showSupplier: {
      default: true
    }
  },
  components: {
    [Option.name]: Option,
    [Select.name]: Select
  },
  data () {
    return {
      statusOptions: orderStatusOptions
    }
  },
  computed: {
    selectClass () {
      return this.statusOptions.find(({ value }) => this.order.status === value).class
    },
    orderSum () {
      return this.order.products.reduce((sum, product) => sum + (product.pivot.quantity * product.pivot.price), 0)
    }
  }
}
</script>

<style>
</style>
